import axios from "axios";

const SETTINGS_URL =
  `${process.env.REACT_APP_API_URL}/caixa` || "http://localhost:3001/api/caixa";

//2025-09-22
export async function getFaturacaoDia(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL + '/faturacao/dia', { headers });

  return response.data;
}

export async function getCaixaDia(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL + '/dia', { headers });

  return response.data;
}

export async function getCaixaMensal(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL + '/mensal', { headers });

  return response.data;
}

//2025-08-20
export async function getCaixaAnual(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL + '/anual', { headers });
  return response.data;
}

//2025-08-20
export async function getModalidadesPagamento(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL + '/modalidades_pagamento/entradas', { headers });
  return response.data;
}

//2025-08-25
export async function getSaidasModalidadesPagamento(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL + '/modalidades_pagamento/saidas', { headers });
  return response.data;
}

